/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chunky_Fine_Shark_BuildInputs */

const fr_chunky_fine_shark_build = /** @type {(inputs: Chunky_Fine_Shark_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cycle`)
};

/**

* @param {Chunky_Fine_Shark_BuildInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const chunky_fine_shark_build = /** @type {((inputs?: Chunky_Fine_Shark_BuildInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chunky_Fine_Shark_BuildInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_chunky_fine_shark_build(inputs)
});